<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "customer",
      key: "id",
      url: {},
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "客户名称",
          name: "customerName",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
          onBlur: this.queryCustomerData,
        },
        {
          label: "客户地址",
          name: "address",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "客户电话",
          name: "mobile",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "客户联系人",
          name: "name",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "客户域名",
          name: "host",
          value: "",
          type: "input",
          width: "300px",
          rules: [{ required: true, trigger: "blur" }],
          onBlur: this.queryCustomerData,
        },
        {
          label: "公司LOGO",
          name: "logo",
          value: "",
          type: "avatar",
          desc: "建议图片宽高尺寸512*512像素及以上",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "版本",
          name: "versionId",
          value: "",
          type: "select",
          width: "300px",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "移动端版本",
          name: "mobileVersionId",
          value: "",
          type: "select",
          width: "300px",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "状态",
          name: "status",
          value: 1,
          type: "switch",
          trueValue: 1,
          falseValue: 0,
        },
      ],
      forms: {
        id: "",
        createBy: $utils.data.get("auth", "customer"),
      },
    };
  },
  created() {
    this.loadLevelData();
    this.loadLevelWeappData();
  },
  methods: {
    initData() {
      // 加载详情数据
      let id = this.kv;
      this.forms.id = id;
      $utils.api.load(`/admin/system/customer/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
        }
      });
    },

    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/version/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.versionName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "versionId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loadLevelWeappData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/mobileVersion/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.versionName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "mobileVersionId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    queryCustomerData() {
      let q = {
        id: this.forms.id,
        customerName: this.forms.customerName,
        host: this.forms.host,
      };

      $utils.api
        .load(`/admin/system/customer/query`, q)
        .then((res) => {})
        .catch((e) => {
          $utils.toast.error(e.message);
        });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/customer`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
  },
};
</script>
